import React,{useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {fetchDetails} from './getDetails';
import Video from './video';


function SearchFeed(props) {
  const {searchId} = useParams();
  const [video,setVideo] = useState([]);
  // alert(searchId);

  useEffect(()=>{
    const getDetails = async()=>{
      const data = await fetchDetails(`search?part=snippet&q=${searchId}`);
      setVideo(data.items);
    }
    getDetails();
    props.HideToShow();
  },[searchId]);
  return (
    <div className='pt-14 bg-[#202020] pl-20 w-full '>
      <Video videos={video} className=""/>
    </div>
  )
}

export default SearchFeed